import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-193" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-194" data-mp="13vjdgd8s8gue">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-195" data-mp="18tuo2q6wivdo">
          DOES THIS SOUND <span className="text-hazard" data-id="element-196" data-mp="1dmnrnaqmvxo6">FAMILIAR?</span>
        </h2>
        <p className="mt-1.5 text-center text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.95rem]" data-id="element-197" data-mp="1ikxnzoo3h4bd">
          You're responsible for keeping the construction site moving—but every day brings new tasks,
          subcontractors, deliveries, unexpected problems, schedule changes, and paperwork demanding
          your attention.
        </p>
        <div className="mt-2 space-y-1.5" data-id="element-198" data-mp="1whupck1ua46i">
          {painPoints.map(p => <div key={p.title} className="rounded-r-md border-l-4 border-hazard bg-ink py-2 pl-2.5 pr-2" data-id="element-199" data-mp="3tds4pjwfsrqb">
              <h3 className="font-display text-[0.74rem] font-bold uppercase leading-tight text-white sm:text-[0.92rem]" data-id="element-200" data-mp="2667oa483nif">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-201" data-mp="2dooliyy7d2qi">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}